import Vue from 'vue'
import { GET_ALLOWANCES } from '../mutation-types.js'

export const getAllowances = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('allowance')
    .then(
      (response) => {
        dispatch(GET_ALLOWANCES, response.json())
        resolve()
      },
      (response) => {
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/allowancesActions.js